import React, { ReactNode } from "react";

export interface SpacerProps {
  children: ReactNode;
}

const Spacer = ({ children }: SpacerProps) => {
  return <div className="my-12 md:my-16">{children}</div>;
};

export default Spacer;
